module.exports = __webpack_public_path__ + "public-ui/img/email.edbb8222.svg";